import MainDataDeletion from './MainDataDeletion.svelte';

const app = new MainDataDeletion({
	target: document.body,
});

export default app;
